import type { OrgRoleView, TenantOrgPermission } from '@nadoutong/contracts';

/**
 * Pre-backend fallback for `GET /v1/org/roles` (tenant #178).
 *
 * The matrix page's only truth is that endpoint. Until the router roles
 * API is deployed to a given environment, a 404/error still has to
 * render the three builtin roles so the tab is usable and dark-safe.
 * These permission sets copy `permissionsForRole` in
 * `hooks/useSession.tsx` (itself a mirror of platform-api
 * `permissionsForOrgRole`) — do not invent names here.
 *
 * Delete this module when every environment serves the live list.
 */
const BUILTIN_MANAGER_PERMISSIONS: readonly TenantOrgPermission[] = [
  'org:members:read',
  'org:members:manage',
  'org:invitations:manage',
  'org:api_keys:read',
  'org:api_keys:manage',
  'member:api_keys:manage',
  'org:billing:read',
  'org:billing:manage',
  'org:usage:read',
  'member:usage:read',
  'org:audit:read',
  'member:audit:read',
  'org:reports:export',
  'member:models:read',
  'member:monthly_limit:read',
  'member:requests:read',
];

const BUILTIN_MEMBER_PERMISSIONS: readonly TenantOrgPermission[] = [
  'member:api_keys:manage',
  'member:usage:read',
  'member:audit:read',
  'member:models:read',
  'member:monthly_limit:read',
  'member:requests:read',
];

export const BUILTIN_ORG_ROLES_FALLBACK: readonly OrgRoleView[] = [
  {
    id: 'owner',
    name: 'owner',
    builtin: true,
    permissions: BUILTIN_MANAGER_PERMISSIONS,
    memberCount: 0,
  },
  {
    id: 'admin',
    name: 'admin',
    builtin: true,
    permissions: BUILTIN_MANAGER_PERMISSIONS,
    memberCount: 0,
  },
  {
    id: 'member',
    name: 'member',
    builtin: true,
    permissions: BUILTIN_MEMBER_PERMISSIONS,
    memberCount: 0,
  },
];
